export const setAiTasks = (tasks) => ({
    type: 'SET_AI_TASKS',
    payload: tasks,
});